import { isEmpty } from "lodash";
import { getJwtCookie } from "../util/jwtCookie";

export default class httpService {
  static async get(resource, params = {}, csrfToken = '') {
    if (!isEmpty(params)) {
      const encodedParams = new URLSearchParams(params).toString();
      resource = `${resource}?${encodedParams}`;
    }

    const headers = await setHeader(csrfToken);

    const options = {
      method: 'GET',
      headers: headers
    };

    const response = await fetch(resource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }

  static async post(resource, params, csrfToken = '') {
    const headers = await setHeader(csrfToken);

    const options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(params)
    }

    const response = await fetch(resource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }

  static async put(resource, params, csrfToken = '') {
    const headers = await setHeader(csrfToken);

    const options = {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(params)
    }

    const response = await fetch(resource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }

  static async remove(resource, params, csrfToken = '') {
    const headers = await setHeader(csrfToken);

    const options = {
      method: 'DELETE',
      headers: headers,
      body: JSON.stringify(params)
    }

    const response = await fetch(resource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }

  static async save(resource, params, csrfToken = '') {
    let method = 'POST';

    if (params.id) {
      method = 'PUT';
      delete params.id;
    }

    const headers = await setHeader(csrfToken);

    const options = {
      method: method,
      headers: headers,
      body: JSON.stringify(params)
    }
    
    const response = await fetch(resource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }

  static async multipart(resource, params, csrfToken = '') {
    const options = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': csrfToken },
      body: params
    }

    const response = await fetch(resource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }

  static async download(resource, csrfToken = '') {
    const options = {
      method: 'GET',
      headers: setHeader(csrfToken)
    };

    const response = await fetch(resource, options).catch(handleFetchError);
    if (!response.ok) throw new Error("Error downloading file");
    return response.blob();
  }
}

const setHeader = async (csrfToken) => {
  const token = await getJwtCookie();
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };

  if (csrfToken) headers['X-CSRF-Token'] = csrfToken;

  return headers;
}

function checkResponse(response, json) {
  if (response.status !== 200) {
    throw {
      message: json.message || json.errors,
      status: response.status
    };
  }
}

function handleFetchError(error) {
  console.log("ERROR FETCHING: ", error);
  throw "We were unable to connect to the server";
}

function handleParsingError(error) {
  console.log("ERROR PARSING JSON: ", error);
  throw "There was an error reading the response from the server";
}
